import React from 'react'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import BodyText from 'components/Luxkit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import AccommodationPackageInclusionsList from '../Accommodation/AccommodationPackageInclusionsList'

interface Props {
  bonusInclusions?: string;
  inclusions?: string;
  /**
   * @default medium
   */
  size?: 'small' | 'medium' | 'large';
}

function InclusionsSection(props: Props) {
  const {
    bonusInclusions,
    inclusions,
    size = 'medium',
  } = props

  return <VerticalSpacer gap={12}>
    {bonusInclusions && <AccommodationPackageInclusionsList title="bonus">
      <BodyText variant={size}>
        <MarkdownRender fontSize={size} type="compact" content={bonusInclusions} />
      </BodyText>
    </AccommodationPackageInclusionsList>}
    {inclusions && <AccommodationPackageInclusionsList title={bonusInclusions ? 'additional' : undefined}>
      <BodyText variant={size}>
        <MarkdownRender fontSize={size} type="compact" content={inclusions} />
      </BodyText>
    </AccommodationPackageInclusionsList>}
  </VerticalSpacer>
}

export default InclusionsSection
